import { defineStore } from 'pinia';
import type { Logo } from '../../types/storeConfig';
import { ref, watch } from 'vue';
import { useStoreConfiguration } from '../configuration/configuration';

export type LogoState = {
  imageConfig?: Logo;
  baseUrl?: string;
  variant?: 'original' | 'inverted';
};

const storeId = 'logo';
const shouldPersist = ref<boolean>(true);

export const useLogoStore = () => {
  const storeConfig = useStoreConfiguration();
  const storeLocale = sessionStorage.getItem('store-locale') || '';

  const innerStore = defineStore(storeId, {
    state: (): LogoState => {
      if (shouldPersist.value) {
        const storage = sessionStorage.getItem(storeId);

        if (storage) {
          return JSON.parse(storage) as LogoState;
        }
      }

      return {};
    },
    actions: {
      initLogo() {
        if (storeConfig && storeConfig.configLogo && storeConfig.caasUrl) {
          this.imageConfig = storeConfig.configLogo;
          this.baseUrl = storeConfig.caasUrl;
          this.variant = 'original';
        }

        if (storeLocale.toLowerCase() !== storeConfig.caasConfig?.locale?.toLowerCase()) {
          shouldPersist.value = false;
        }

        if (shouldPersist.value) {
          this.persist();
        }
      },
      persist() {
        sessionStorage.setItem(
          storeId,
          JSON.stringify({
            imageConfig: this.imageConfig,
            baseUrl: this.baseUrl,
            variant: this.variant,
          }),
        );
      },
    },
  });

  const store = innerStore();

  watch(storeConfig, () => {
    if (
      storeConfig.configLogo &&
      storeConfig.caasConfig &&
      (!store.baseUrl || !store.imageConfig || !store.variant)
    ) {
      store.initLogo();
    }
  });

  return store;
};
